import { useRef, useState } from "react";

export const TagInput = ({ value = [], options = [], onChange, onCreate, placeholder = "Type to search…", testId = "tag-input" }) => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const inputRef = useRef(null);

  const selected = value.map((id) => options.find((o) => o.id === id)).filter(Boolean);
  const matches = options.filter((o) => !value.includes(o.id) && o.name.toLowerCase().includes(q.trim().toLowerCase()));
  const canCreate = Boolean(onCreate && q.trim() && !options.some((o) => o.name.toLowerCase() === q.trim().toLowerCase()));
  const total = matches.length + (canCreate ? 1 : 0);

  const add = (id) => {
    onChange([...value, id]);
    setQ("");
    setHi(0);
  };
  const create = async () => {
    const created = await onCreate(q.trim());
    if (created?.id) add(created.id);
  };
  const choose = (index) => {
    if (index < matches.length) add(matches[index].id);
    else if (canCreate) create();
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (total) choose(hi);
    } else if (e.key === "Backspace" && !q && value.length) {
      onChange(value.slice(0, -1));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setHi((h) => Math.min(h + 1, total - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHi((h) => Math.max(h - 1, 0));
    } else if (e.key === "Escape") {
      setOpen(false);
    }
  };

  return (
    <div className="relative" data-testid={testId}>
      <div
        className="min-h-10 flex flex-wrap gap-1.5 items-center rounded-md border border-[#D1D5DB] bg-white px-2 py-1.5 focus-within:border-[#111] focus-within:ring-2 focus-within:ring-[#F8D481]/40 cursor-text"
        onClick={() => inputRef.current?.focus()}
      >
        {selected.map((s) => (
          <span key={s.id} className="inline-flex items-center gap-1 rounded bg-[#F3E8FF] text-[#6B21A8] px-2 py-0.5 text-[13px] font-medium" data-testid={`${testId}-chip`}>
            {s.name}
            <button type="button" className="hover:text-black leading-none" onClick={(e) => { e.stopPropagation(); onChange(value.filter((v) => v !== s.id)); }} aria-label={`Remove ${s.name}`}>
              ×
            </button>
          </span>
        ))}
        <input
          ref={inputRef}
          value={q}
          onChange={(e) => { setQ(e.target.value); setOpen(true); setHi(0); }}
          onFocus={() => setOpen(true)}
          onBlur={() => setTimeout(() => setOpen(false), 120)}
          onKeyDown={onKeyDown}
          placeholder={selected.length ? "" : placeholder}
          className="flex-1 min-w-[120px] h-7 bg-transparent outline-none text-[14px]"
          data-testid={`${testId}-field`}
        />
      </div>
      {open && total > 0 && (
        <div className="absolute z-20 mt-1 w-full bg-white border border-[#E5E7EB] rounded-md shadow-lg max-h-56 overflow-auto py-1" data-testid={`${testId}-menu`}>
          {matches.map((m, i) => (
            <button
              key={m.id}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); add(m.id); }}
              onMouseEnter={() => setHi(i)}
              className={`w-full text-left px-3 py-1.5 text-[13px] ${i === hi ? "bg-[#F3F4F6]" : ""}`}
              data-testid={`${testId}-option`}
            >
              {m.name}
            </button>
          ))}
          {canCreate && (
            <button
              type="button"
              onMouseDown={(e) => { e.preventDefault(); create(); }}
              onMouseEnter={() => setHi(matches.length)}
              className={`w-full text-left px-3 py-1.5 text-[13px] text-[#3B5BDB] ${hi === matches.length ? "bg-[#F3F4F6]" : ""}`}
              data-testid={`${testId}-create`}
            >
              Create “{q.trim()}”
            </button>
          )}
        </div>
      )}
    </div>
  );
};
